import { z } from 'zod';
const zipDigits = (value) => value.replace(/\D/g, '');
/** True when ZIP has exactly 9 digits (hyphens ignored). Used for claim N403 / agency address. */
export const isZipPlus4 = (zipcode) => {
    if (!zipcode) {
        return false;
    }
    return zipDigits(zipcode).length === 9;
};
/**
 * Validates a ZIP code - must be either 5 digits or 9 digits (5+4 format)
 */
export const validateZipCode = (value) => {
    if (!value) {
        return true; // Let required validation handle empty values
    }
    const digits = zipDigits(value);
    return digits.length === 5 || digits.length === 9;
};
/** Zod refine helper: empty deferred to required(); otherwise ZIP+4. */
const validateZipPlus4 = (value) => !value || isZipPlus4(value);
const addressFields = {
    address: z.string().min(1, 'Address is required'),
    city: z.string().min(1, 'City is required'),
    state: z.string().min(2, 'State is required'),
};
export const addressValidationSchema = z.object({
    ...addressFields,
    zipcode: z.string().min(1, 'Zip code is required').refine(validateZipCode, {
        message: 'ZIP code must be 5 digits or 9 digits (ZIP+4)',
    }),
});
/** Org/company/branch address — ZIP+4 required for claim N403. */
export const addressZipPlus4ValidationSchema = z.object({
    ...addressFields,
    zipcode: z.string().min(1, 'Zip code is required').refine(validateZipPlus4, {
        message: 'ZIP+4 is required (9 digits)',
    }),
});
export const addressOptionalValidationSchema = z.preprocess((raw) => {
    if (raw &&
        ['address', 'city', 'state', 'zipcode'].every((k) => {
            const v = raw[k];
            return v == null || (typeof v === 'string' && v.trim() === '');
        })) {
        return undefined;
    }
    return raw;
}, addressValidationSchema.optional());
